import React from "react";
import echarts from "echarts/lib/echarts";
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";

import { colorList } from "./chartDef";

class MultiLine extends React.Component {
  state = {
    domId: "chart_line_" + Math.random(),
    chart: null,
  };

  componentDidMount() {
    // 初始化
    //this.props.refreshChart(this.refreshChart);
    window.addEventListener("resize", this.handleResize, false);
  }
  componentWillUnmount() {
    //一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
    window.removeEventListener("resize", this.handleResize, false);
  }
  handleResize = (e) => {
    this.state.chart.resize();
  };

  componentWillReceiveProps(nextProps) {
    this.refreshChart(nextProps);
  }

  refreshChart(props) {
    let { data, xData, title, yNames } = props;
    console.log(xData);
    var yAxis = [];
    yNames.forEach((name) => {
      yAxis.push({ name, type: "value" });
    });
    let legend = {
      // data: ['总金额', '到账总金额'],
      x: "center",
      // y:'bottom',
      y: "30",
      // orient: 'vertical',
      // orient: 'horizontal'
    };
    let legendData = [];
    let series = [];
    for (let i = 0; i < data.length; i++) {
      legendData.push(data[i].text);
      var s = {
        data: data[i].data,
        name: data[i].text,
        yAxisIndex: data[i].yAxisIndex || 0,
        type: "line",
        //直线和波浪线
        smooth: false,
        areaStyle: data[i].area,
      };
      if (data[i].valueFormatter) {
        s.tooltip = { valueFormatter: data[i].valueFormatter };
      }
      series.push(s);
    }
    console.log(series);
    legend.data = legendData;
    let option = {
      color: colorList,
      title: {
        text: title,
        x: "center", //位置
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          animation: false,
          label: {
            backgroundColor: "#505765",
          },
        },
      },
      legend: legend,
      grid: {
        left: "5%",
        right: "5%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: xData,
      },
      yAxis,
      series,
    };
    console.log(this.state.domId, option);
    if (this.state.chart == null) {
      let chart = echarts.init(document.getElementById(this.state.domId));
      this.setState({ chart: chart });
      chart.setOption(option);
    } else {
      this.state.chart.setOption(option);
    }
  }

  render() {
    return (
      <div
        id={this.state.domId}
        style={{ width: "100%", height: this.props.height || "100%" }}
      ></div>
    );
  }
}

export default MultiLine;
